export default __webpack_public_path__ + "static/media/ebook.5c209a2a.svg";